<div class="module-selector">
  <h2>Choisissez votre module</h2>

  <div class="cards">
    <p-card header="CAC" subheader="Assurance emprunteur" styleClass="module-card">
      <ng-template pTemplate="footer">
        <button pButton type="button" label="Accéder à CAC" (click)="goToCAC()"></button>
      </ng-template>
    </p-card>

    <p-card header="CAS" subheader="Assurance santé" styleClass="module-card">
      <ng-template pTemplate="footer">
        <button pButton type="button" label="Accéder à CAS" (click)="goToCAS()"></button>
      </ng-template>
    </p-card>
  </div>
</div>

